<template>
  <v-list dense>
    <template v-for="item in items_customer">
      <v-list-item
        v-if="($store.getters.user.data.admin || item.show || (!item.show && $store.getters.user.data.active && $store.getters.user.data.covered))"
        :key="item.text"
        link
        exact
        :to="{ name: item.to }"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <v-subheader v-if="this.$store.getters.user.data.admin">
      <v-icon class="px-2">developer_board</v-icon>
      <span class="ml-6">{{ $t('menu.admin.subtitle') }}</span>
    </v-subheader>
    <template v-for="item in items_admin">
      <v-list-item
        :key="item.text"
        link
        exact
        :to="{ name: item.to }"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <v-overlay v-if="!$store.getters.user.data.admin && !$store.getters.user.data.premium" :value="$store.getters.user.data.covered === null" opacity="1" color="white" light absolute>
      <v-progress-circular indeterminate size="64" color="primary"></v-progress-circular>
    </v-overlay>
  </v-list>
</template>

<script>
  export default {
    data: () => ({
      items_customer: [],
      items_admin: []
    }),

    mounted: function () {
      let premium = this.$store.getters.user.data.premium

      this.items_customer = [
        {
          icon: 'home',
          text: this.$t('menu.customer.home'),
          to: 'Dashboard',
          show: premium
        },
        {
          icon: 'video_library',
          text: this.$t('menu.customer.library'),
          to: 'Library',
          show: premium
        },
        {
          icon: 'search',
          text: this.$t('menu.customer.explore'),
          to: 'Explore',
          show: premium
        },
        {
          icon: 'favorite',
          text: this.$t('menu.customer.favorites'),
          to: 'Favorites',
          show: premium
        },
        {
          icon: 'settings',
          text: this.$t('menu.customer.my-account'),
          to: 'Account',
          show: true
        }
      ]

      if (!premium && !this.$store.getters.user.data.admin) {
        this.items_customer.push({
          icon: 'payment',
          text: this.$t('menu.customer.billing'),
          to: 'Billing',
          show: true
        })
      }

      if (!this.$store.getters.user.data.admin) {
        return
      }
      this.items_admin = [
        /* Admin */
        {
          icon: 'person',
          text: this.$t('menu.admin.users'),
          to: 'AdminUsers'
        },
        {
          icon: 'subscriptions',
          text: this.$t('menu.admin.plans'),
          to: 'AdminPlans'
        },
        {
          icon: 'extension',
          text: this.$t('menu.admin.components'),
          to: 'AdminComponents'
        },
        {
          icon: 'category',
          text: this.$t('menu.admin.categories'),
          to: 'AdminCategories'
        },
        {
          icon: 'video_collection',
          text: this.$t('menu.admin.videos'),
          to: 'AdminVideos'
        },
        {
          icon: 'settings',
          text: this.$t('menu.admin.settings'),
          to: 'AdminSettings'
        }
      ]
    }
  }
</script>
